// AddToCartButton.jsx
import React from "react";
import { Button } from 'primereact/button';

const AddToCartButton = (prop) => {
    
    const { onClick, label = "Add to Cart", icon = "pi pi-shopping-cart", className = "", fullWidth = true } = prop || {};

    const buttonStyles = {
        background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
        border: '2px solid var(--primary-blue-color)',
        borderRadius: '10px',
        color: 'var(--primary-blue-color)',
        fontWeight: '600',
        fontSize: '12px',
        height: '38px',
        width: fullWidth ? '100%' : 'auto',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 4px rgba(33, 150, 243, 0.1)',
        cursor: 'pointer'
    };

    const hoverStyles = {
        background: 'linear-gradient(135deg, #f5f5f5 0%, #bbdef5 100%)',
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 8px rgba(33, 150, 243, 0.2)'
    };

    const handleMouseEnter = (e) => {
        Object.assign(e.currentTarget.style, hoverStyles);
    };

    const handleMouseLeave = (e) => {
        Object.assign(e.currentTarget.style, buttonStyles);
    };

    return (
        <div style={{ width: '100%', textAlign: 'left' }}>
            <Button 
                label={label}
                icon={icon}
                onClick={onClick}
                className={className}
                style={buttonStyles}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            />
        </div>
    );
};

export default AddToCartButton;